import axios from "axios";
import { saveAs } from "file-saver";
import { extractIDs } from "../../../helpers/extractIDs";
import { getErrorBlob } from "helpers/extractError";
import { handleBlobFile } from "../../../helpers/handleBlobFile";
import { invoicesTypes } from "../../reducers/invoices/types";
import { START_REQUEST_SEARCH } from "../../reducers/search/searchReducer";
import { api_get, api_post, PROYECT } from "../../../services/api";
import {
  setSnackbar,
  startRequestComp,
  stopRequestComp,
  restoreSingleConfigTable,
} from "../search/searchActions";

const {
  CLEAR_INVOICES,
  SET_INPUTS,
  GET_INVOICES,
  CANCEL_INVOICE,
  SUBSTITUTE_INVOICE,
  SELECT_INVOICE_ID,
  SET_EMAIL_INVOICE,
  SET_FORM_CANCEL_INVOICE,
  SET_FORM_SUBSTITUTE_INVOICE,
  UPDATE_FILES_INVOICE,
  CHECK_NOTE_MIGRATIONS,
} = invoicesTypes;

const qid = process.env.REACT_APP_QID_INVOICES;
const mainUrl = `${process.env.REACT_APP_URL_PAY}/invoices`;

export const handleInvoicesInputs = (key = "", value = "") => {
  return {
    type: SET_INPUTS,
    payload: {
      key,
      value,
    },
  };
};

export const getInvoicesPaymentTypes = () => {
  const url = `${process.env.REACT_APP_URL}${PROYECT}/payments`;
  return async (dispatch) => {
    dispatch(startRequestComp("substituteInvoiceLoading"));
    await api_get(url)
      .then((resp) => {
        if (resp.length === 0)
          dispatch(setSnackbar("No se encontraron tipos de pago"));
        dispatch(
          handleInvoicesInputs(
            "paymentTypes",
            resp
              .filter((payment) => payment.name !== "CONDONACION" && payment.forStamp === 1)
              .map((payment) => ({
                ...payment,
                value: payment.id,
                label: payment.name,
                type: payment.method,
              })),
          ),
        );
      })
      .catch((error) =>
        dispatch(
          setSnackbar(error ? error : "Error contacte al administrador"),
        ),
      );
    dispatch(stopRequestComp("substituteInvoiceLoading"));
  };
};

export const getInvoicesPDF = (token, stations, start, end, stationsNames) => {
  const namePDF = `Facturas_${stationsNames.join("_")}_${start}_${end}.pdf`;
  const paramsString = `?qid=${qid}&start=${start}&end=${end}&stations=${stations.join(
    "&stations=",
  )}`;
  const options = {
    method: "GET",
    url: `${mainUrl}/report${paramsString}`,
    headers: { Authorization: token },
    responseType: "blob",
  };
  return async (dispatch) => {
    dispatch(startRequestComp("downloadInvoicesLoading"));
    await axios
      .request(options)
      .then((response) => {
        saveAs(response.data, namePDF);
        dispatch(setSnackbar(`Descargando archivo ${namePDF}`, "info"));
        dispatch(stopRequestComp("downloadInvoicesLoading"));
      })
      .catch(async (error) => {
        dispatch(setSnackbar(await getErrorBlob(error)));
        dispatch(stopRequestComp("downloadInvoicesLoading"));
      });
  };
};

export const getInvoices = (start, end, stations) => {
  const ids = extractIDs(stations);
  const paramsString = `?qid=${qid}&start=${start}&end=${end}&stations=${ids.join(
    "&stations=",
  )}`;
  const url = `${mainUrl}/report/table${paramsString}`;
  return async (dispatch) => {
    dispatch(restoreSingleConfigTable("invoices"));
    dispatch(startRequestComp("invoicesLoading"));
    dispatch({ type: START_REQUEST_SEARCH });
    await api_get(url)
      .then((resp) => {
        if (!Array.isArray(resp)) {
          dispatch(setSnackbar("La respuesta de facturas no es válida, intente de nuevo"));
        } else if (resp.length === 0) {
          dispatch(setSnackbar("No se encontraron facturas", "info"));
        }
        dispatch({
          type: GET_INVOICES,
          payload: resp,
        });
      })
      .catch((error) => {
        dispatch(setSnackbar(error));
      });
    dispatch(stopRequestComp("invoicesLoading"));
  };
};

export const selectInvoiceId = (id) => {
  return {
    type: SELECT_INVOICE_ID,
    payload: id,
  };
};

export const setFormCancelInvoice = (input) => {
  return {
    type: SET_FORM_CANCEL_INVOICE,
    payload: input,
  };
};

export const setFormSubstituteInvoice = (input) => {
  return {
    type: SET_FORM_SUBSTITUTE_INVOICE,
    payload: input,
  };
};

export const emailModal = (input) => {
  return {
    type: SET_EMAIL_INVOICE,
    payload: input,
  };
};

export const cancelInvoice = (id = "", form, onSuccess = null) => {
  const url = `${mainUrl}/${id}/cancel?qid=${qid}`;
  return async (dispatch) => {
    dispatch(startRequestComp("cancelInvoiceLoading"));
    try {
      const resp = await api_post(url, form);
      if (resp?.isInstantlyCancelled) saveAs(resp.url, `Acuse-${id}.xml`);
      dispatch({
        type: CANCEL_INVOICE,
        payload: {
          id,
          isInstantlyCancelled: resp?.isInstantlyCancelled,
          url: resp?.url,
        },
      });
      dispatch(setSnackbar(resp?.message, "success"));
      dispatch(setFormCancelInvoice(false));
      onSuccess && onSuccess();
    } catch (error) {
      dispatch(setSnackbar(error || "Error contacte a soporte"));
    } finally {
      dispatch(stopRequestComp("cancelInvoiceLoading"));
    }
  };
};

export const substituteInvoice = (id = "", form, newPayment) => {
  const url = `${mainUrl}/${id}/replacement?qid=${qid}`;
  return async (dispatch) => {
    dispatch(startRequestComp("substituteInvoiceLoading"));
    await api_post(url, form)
      .then((resp) => {
        if (resp.new) saveAs(resp.new, `Nueva-Factura-${resp.newId || id}.xml`);
        if (resp.newPdf) saveAs(resp.newPdf, `Nueva-Factura-${resp.newId || id}.pdf`);
        dispatch({
          type: SUBSTITUTE_INVOICE,
          payload: {
            id,
            newId: resp?.newId,
            isInstantlyCancelled: resp?.replacement?.isInstantlyCancelled,
            new: resp?.new,
            payment: newPayment,
            replacement: resp?.replacement,
          },
        });
        if (!Object.keys(resp?.replacement || {}).length)
          dispatch(
            setSnackbar(
              "La factura remplazada no ha sido cancelada",
              "warning",
            ),
          );
        else dispatch(setSnackbar(resp?.message, "success"));
      })
      .catch((error) => {
        dispatch(setSnackbar(error || "Error contacte a soporte"));
      });
    dispatch(setFormSubstituteInvoice(false));
    dispatch(stopRequestComp("substituteInvoiceLoading"));
  };
};

export const downloadInvoiceFile = (id, active = false, accuse = false) => {
  return async (dispatch) => {
    dispatch(startRequestComp("downloadInvoiceLoading"));
    const baseUrl = `${mainUrl}/${id}/downloads?qid=${qid}&`;
    const filesParams = `${!active ? "xml=true" : "pdf=true"}`;
    const accuseParams = `accuse=${accuse}`;
    const url = `${baseUrl}${accuse ? accuseParams : filesParams}`;
    try {
      await api_get(url).then((response) => {
        if (!accuse) {
          const fileType = `${id}.${!active ? "xml" : "pdf"}`;
          const resp = !active ? response.xml : response.pdf;
          saveAs(resp, fileType);
        } else {
          saveAs(response?.accuse, `Acuse-${id}.xml`);
        }
      });
    } catch (error) {
      dispatch(setSnackbar(error));
    }
    dispatch(stopRequestComp("downloadInvoiceLoading"));
  };
};

export const regenerateFilesInvoice = (id, form, folio, close = null) => {
  const url = `${mainUrl}/${id}/regenerate-xml-pdf?qid=${qid}`;
  return async (dispatch) => {
    dispatch(startRequestComp("downloadInvoiceLoading"));
    await api_post(url, form)
      .then((resp) => {
        dispatch({
          type: UPDATE_FILES_INVOICE,
          payload: { id },
        });
        const message = `Factura con folio: ${folio} -  ${resp?.message}`;
        dispatch(setSnackbar(message, "success"));
        close && close();
      })
      .catch((error) => {
        dispatch(setSnackbar(error || "Error contacte a soporte"));
      });
    dispatch(stopRequestComp("downloadInvoiceLoading"));
  };
};

export const forwardEmail = (id, form, close = null) => {
  const url = `${mainUrl}/${id}/resend?qid=${qid}`;
  return async (dispatch) => {
    dispatch(startRequestComp("forwardEmailLoading"));
    await api_post(url, form)
      .then((_resp) => {
        dispatch(setSnackbar("Mensaje Enviado con éxito", "success"));
        dispatch(stopRequestComp("forwardEmailLoading"));
        close && close();
      })
      .catch((error) => {
        dispatch(stopRequestComp("forwardEmailLoading"));
        dispatch(setSnackbar(error));
      });
  };
};

export const clearInvoices = () => {
  return {
    type: CLEAR_INVOICES,
  };
};

export const downloadPromissoryNote = (id) => {
  const url = `${mainUrl}/${id}/promissory_note?qid=${qid}`;
  return async (dispatch) => {
    dispatch(startRequestComp("downloadPromissoryNoteLoading"));
    await api_get(url, {
      responseType: "blob",
    })
      .then((response) => {
        handleBlobFile(response, {
          name: `${id}.pdf`,
          download: true,
        });
        dispatch(setSnackbar("Pagaré generado", "success"));
      })
      .catch((error) => {
        dispatch(setSnackbar(error));
      });
    dispatch(stopRequestComp("downloadPromissoryNoteLoading"));
  };
};

// Solo la petición más reciente actualiza el estado, para que una respuesta
// tardía de otra factura no pinte el switch en la factura actual.
let lastCheckRequestId = 0;

export const checkNoteMigrations = (id) => {
  const url = `${mainUrl}/${id}/check-note-migrations?qid=${qid}`;
  return async (dispatch) => {
    const requestId = ++lastCheckRequestId;
    const isLatest = () => requestId === lastCheckRequestId;

    dispatch({ type: CHECK_NOTE_MIGRATIONS, payload: false });
    dispatch(startRequestComp("checkNoteMigrationsLoading"));
    try {
      const resp = await api_get(url);
      if (!isLatest()) return;
      dispatch({
        type: CHECK_NOTE_MIGRATIONS,
        payload: resp?.askForCancelMigration || false,
      });
    } catch (error) {
      if (!isLatest()) return;
      dispatch({ type: CHECK_NOTE_MIGRATIONS, payload: false });
      dispatch(
        setSnackbar(
          error || "No se pudo verificar si la factura tiene migraciones a Oracle. Proceda con precaución.",
          "warning",
        ),
      );
    } finally {
      if (isLatest()) dispatch(stopRequestComp("checkNoteMigrationsLoading"));
    }
  };
};
